import React from "react";
import { Step } from "semantic-ui-react";
import { connect } from "react-redux";
import {
  REGISTER_FASE_IDENTIFICATION,
  REGISTER_FASE_VALIDATION,
  REGISTER_FASE_CONFIRMATION,
} from "../../../../../app/infrastructure/appConstants";
import PropTypes from "prop-types";

const mapState = (state) => ({
  fase: state.registerUser.fase,
});
const RegisterFormStep = ({ fase }) => {
  return (
    <Step.Group ordered fluid>
      <Step
        completed={fase > REGISTER_FASE_IDENTIFICATION}
        active={fase === REGISTER_FASE_IDENTIFICATION}
      >
        <Step.Content>
          <Step.Title>Identificación</Step.Title>
        </Step.Content>
      </Step>

      <Step
        completed={fase > REGISTER_FASE_VALIDATION}
        active={fase === REGISTER_FASE_VALIDATION}
      >
        <Step.Content>
          <Step.Title>Validación</Step.Title>
        </Step.Content>
      </Step>

      <Step
        completed={fase > REGISTER_FASE_CONFIRMATION}
        active={fase === REGISTER_FASE_CONFIRMATION}
      >
        <Step.Content>
          <Step.Title>Confirmación</Step.Title>
        </Step.Content>
      </Step>
    </Step.Group>
  );
};

RegisterFormStep.propTypes = {
  fase: PropTypes.number.isRequired,
};

export default connect(mapState, null)(RegisterFormStep);
